// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {perr} from 'hola_pub_util';
import {i_zone_config, Proxy_type, t_order_users_state} from '../../../hola/pub/ui/pro/cp/orders';
import hola_opt from 'hola_opt';
import {i_user_info} from 'hola_app_context';
import {t_zone_action} from './use_dashboard_data';
// @ts-ignore
import {inet_ntoa_t} from '/util/conv.js';
import {i_instruction} from './sessions/types';

const manual_oculus_renew = (zone_id: string)=>
etask(function*(){
    try {
        const res = yield fetch('/users/payment/manual_oculus_renew', {
            method: 'POST',
            json: true,
            body: {zone_id}
        });
        perr({id: 'oculus_manual_renew_from_dashboard'});
        return {err: res?.result?.error, ok: !res?.result?.error};
    } catch(e){
        console.error(e);
        return {err: 'unknown'};
    }
});

const update_auto_renewal = (zone_id: string, auto_renew: boolean)=>
etask(function*(){
    try {
        const res = yield fetch('/users/payment/update_auto_renewal'
          +'?no_redirect=1', {
            method: 'POST',
            json: true,
            body: {zone_id, auto_renew}
        });
        perr({id: 'oculus_update_auto_renewal_from_dashboard'});
        return {err: res?.result?.error, ok: res=='ok'};
    } catch(e){
        console.error(e);
        return {err: 'unknown'};
    }
});

type i_update_extra_limit_renewal_params =
    | { group_id: string; enable: boolean; limit_gb: number }
    | { zone_id: string; enable: boolean; limit_gb: number };

const update_extra_limit_renewal =
(params: i_update_extra_limit_renewal_params)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        const res = yield fetch('/users/payment/update_extra_limit_renewal',
        {
            method: 'POST',
            json: true,
            body: params
        });
        perr({
            id: site+'_update_extra_limit_renewal_from_dashboard',
            info: params,
        });
        if (params.enable)
            perr({id: site+'_enable_extra_limit_auto_renewal'});
        return res;
    } catch(e){
        console.error(e);
        return {err: 'unknown'};
    }
});

type i_buy_extra_limit_params =
    | {zone_id: string; auto_renew?: boolean; gb: number;}
    | {group_id: string; auto_renew?: boolean; gb: number;};
const buy_extra_limit = (params: i_buy_extra_limit_params)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        const res = yield fetch('/users/payment/buy_extra_limit', {
            method: 'POST',
            json: true,
            body: params
        });
        perr({
            id: site+'_buy_extra_limit_from_dashboard',
            info: params,
        });
        if (params.auto_renew)
            perr({id: site+'_enable_extra_limit_auto_renewal'});
        return res;
    } catch(e){
        console.error(e);
        return {error: 'unknown'};
    }
});

const create_free_zone = (type: Proxy_type)=>etask(function*(){
    const {site} = hola_opt.www_hola;
    perr({id: site+'_create_free_zone_from_dashboard'});
    const res = yield fetch('/api/create_free_by_type',
        {method: 'POST', body: {type}});
    return res?.zone ?? null;
});

const create_zone_for_group =
(group_id: string, type: Proxy_type, name?: string)=>{
    const {site} = hola_opt.www_hola;
    const event_type = `${site}_create_zone_for_group`;
    perr({id: site+'_create_zone_for_group_from_dashboard'});
    return fetch('/api/groups/zone', {method: 'POST',
        body: {group_id, type, name, event_type}});
};

const update_orders_user_state =
(order_ids: string[], user_state: Partial<t_order_users_state>)=>{
    const {site} = hola_opt.www_hola;
    perr({id: site+'_create_zone_for_group_from_dashboard'});
    return fetch('/api/orders/orders_user_state', {
        method: 'PUT',
        json: true,
        body: {order_ids, user_state}}
    );
};

const update_user_ui_state =(state: Partial<i_user_info['ui_state']>)=>{
    const {site} = hola_opt.www_hola;
    perr({id: site+'_update_user_ui_state'});
    return fetch('/api/user_ui_state', {
        method: 'PUT',
        json: true,
        body: {state}}
    );
};

const generate_kyc_access_token = ()=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        perr({
            id: site+'_generate_kyc_access_token',
            info: {hola_uid: hola_opt.user.hola_uid}
        });
        const res = yield fetch('/api/generate_kyc_access_token',
            {method: 'POST', json: true, body: {}});
        const {token} = res;
        return {token};
    } catch(e){
        console.error('Error fetching KYC token:', e);
        return {error: 'unknown'};
    }
});

const check_kyc_status = ()=>etask(function*(){
    try {
        const res = yield fetch('/api/check_kyc_status');
        const {status} = res;
        return {status};
    } catch(e){
        console.error('Error fetching KYC status:', e);
        return {error: 'unknown'};
    }
});

const zone_set_use_case = (id: string, use_case: string)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        perr({id: site+'_zone_set_use_case'});
        const res = yield fetch(`/api/zones/${id}/use_case`, {
            method: 'PUT',
            body: {use_case}
        });
        return res;
    } catch(e){
        return {error: 'unknown'};
    }
});

const zone_rotate_by_country =
(id: string, country: string)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        perr({id: site+'_zone_rotate_by_country'});
        const res = yield fetch(`/api/zones/${id}/rotate_by_country`, {
            method: 'PUT',
            body: {country}
        });
        return res;
    } catch(e){
        return {error: 'unknown'};
    }
});

const delete_payment_method = (id: string)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        perr({id: site+'_delete_payment_method'});
        const res = yield fetch('/users/payment/payment_method', {
            method: 'PUT',
            body: {id}
        });
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to delete: ${e.hola_info.response_text}`
            : 'Failed to delete!';
        return {error};
    }
});

const get_zone_sessions = (zone_id: string)=>etask(function*(){
    try {
        const res = yield fetch(`/api/zones/${zone_id}/sessions`);
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to get sessions: ${e.hola_info.response_text}`
            : 'Failed to get sessions!';
        return {error};
    }
});

const update_zone_config = (id: string, config: Partial<i_zone_config>)=>{
    const {site} = hola_opt.www_hola;
    perr({id: site+'_update_zone_config'});
    return fetch(`/api/zones/${id}/config`, {
        method: 'PUT',
        json: true,
        body: {config}
    });
};

const update_zone = (id: string, update: any, type?:string)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        const {hola_uid} = hola_opt.user;
        const ip = inet_ntoa_t(hola_opt.user_ip);
        perr({id: site+'_update_zone'});
        const res = yield fetch(`/api/zones/${id}`, {
            method: 'PUT',
            json: true,
            body: {...update, hola_uid, type, ip}
        });
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to update zone: ${e.hola_info.response_text}`
            : 'Failed to update zone!';
        return {error};
    }
});

const do_zone_action = (id: string, action: t_zone_action)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        perr({id: site+'_zone_action'});
        const res = yield fetch(`/api/zones/${id}/action`, {
            method: 'PUT',
            json: true,
            body: {action}
        });
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to start action: ${e.hola_info.response_text}`
            : 'Failed to start action!';
        return {error};
    }
});

const archive_zone_toggle = (id: string, archive: boolean,
name: string)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        const {hola_uid} = hola_opt.user;
        const ip = inet_ntoa_t(hola_opt.user_ip);
        perr({id: site+'_archive_zone'});
        const res = yield fetch(`/api/zones/${id}/archive`, {
            method: 'PUT',
            json: true,
            body: {archive, hola_uid, ip, name}
        });
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to archive zone: ${e.hola_info.response_text}`
            : 'Failed to archive zone!';
        return {error};
    }
});

const zone_update_usage_limit = (id: string, limit: any)=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        perr({id: site+'_zone_update_usage_limit'});
        const res = yield fetch(`/api/zones/${id}`, {
            method: 'PUT',
            body: {usage_limit: limit}
        });
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to update zone usage limit: ${e.hola_info.response_text}`
            : 'Failed to update zone usage limit!';
        return {error};
    }
});

const zone_update_whitelist = (id: string, ips: string[])=>etask(function*(){
    try {
        const {site} = hola_opt.www_hola;
        perr({id: site+'_zone_update_usage_limit'});
        const res = yield fetch(`/api/zones/${id}/whitelist`, {
            method: 'PUT',
            json: true,
            body: {ips},
        });
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to update ips whitelist: ${e.hola_info.response_text}`
            : 'Failed to update ips whitelist!';
        return {error};
    }
});
const get_task_result_by_session_id = (id: string, session_id: string)=>
    etask(function*(){
    try {
        const res = yield fetch(`/api/zones/${id}/session`+
            `/${session_id}/task_results`);
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to get tasks: ${e.hola_info.response_text}`
            : 'Failed to get tasks!';
        return {error};
    }
});
const get_resource_from_task_result_by_id = (id: string,
    session_id: string, task_result_id: string)=>
    etask(function*(){
    try {
        const res = yield fetch(`/api/zones/${id}/session`+
            `/${session_id}/task/${task_result_id}/task_resources`);
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to get tasks: ${e.hola_info.response_text}`
            : 'Failed to get tasks!';
        return {error};
    }
});

const get_zone_usage_stats = (id:string, start: string,
    end: string)=>etask(function*(){
    try {
        const res = yield fetch(`/api/zones/${id}/usage_stats`
            +`?start=${start}&until=${end}`);
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to get usage stats: ${e.hola_info.response_text}`
            : 'Failed to get usage stats!';
        return {error};
    }
});

const get_account_bootstrap = ()=>etask(function*(){
    try {
        const res = yield fetch(`/users/account/bootstrap`);
        return res;
    } catch(e){
        const error = e?.hola_info?.response_text
            ? `Failed to get active subscr stats: ${e.hola_info.response_text}`
            : 'Failed to get active subscr!';
        return {error};
    }
});

interface i_create_task_params {
    instructions?: i_instruction[];
    saved_task_names?: string[];
    geo_location: string;
    project: string;
    inspect?: boolean;
    awaitable?: boolean;
    type?: 'natural_language' | 'stagehand'
}
const create_new_task =(params: i_create_task_params)=>etask(function*(){
    try {
        const {
            instructions,
            geo_location,
            project,
            inspect,
            saved_task_names,
            awaitable
        } = params;
        const res = yield fetch('/api/v1/tasks', {
            method: 'POST',
            json: true,
            body: {
                instructions, project,
                saved_task_names,
                geoLocation: {country: geo_location},
                inspect, awaitable,
            },
        });
        return res;
    } catch(e){
        console.error('Error creating task:', e);
        return {error: 'unknown'};
    }
});

interface i_task_add_instructions_params {
    task_id: string;
    instructions: i_instruction[];
}
const task_add_instructions = (params: i_task_add_instructions_params)=>
etask(function*(){
    try {
        const {task_id, instructions} = params;
        const res = yield fetch(`/api/v1/tasks/${task_id}/instructions`, {
            method: 'POST',
            json: true,
            body: {instructions},
        });
        return res;
    } catch(e){
        console.error('Error creating task:', e);
        return {error: 'unknown'};
    }
});
interface i_task_send_command_params {
    task_id: string;
    command: 'stop';
    payload?: any;
}
const task_send_command = (params: i_task_send_command_params)=>
etask(function*(){
    try {
        const {task_id, command, payload} = params;
        const res = yield fetch(`/api/v1/tasks/${task_id}/command`, {
            method: 'POST',
            json: true,
            body: {command, payload},
        });
        return res;
    } catch(e){
        console.error('Error sending task command:', e);
        return {error: 'unknown'};
    }
});

interface i_refresh_ips_params {
    zone_id: string;
    country: string;
    ips: string[];
    socks5: boolean;
}
const refresh_ips = (params: i_refresh_ips_params)=>etask(function*(){
    try {
        const res = yield fetch('/api/ips/refresh', {
            method: 'PUT',
            json: true,
            body: params,
        });
        return res;
    } catch(e){
        console.error('Error refreshing IPS:', e);
        return {error: 'unknown'};
    }
});

interface i_configure_proxies_params {
    id: string;
    country: string;
    quantity: number;
    socks5: boolean;
    split?: boolean;
}
const configure_proxies = (params: i_configure_proxies_params)=>
etask(function*(){
    try {
        const res = yield fetch('/api/proxies/configure', {
            method: 'POST',
            json: true,
            body: params,
        });
        return res;
    } catch(e){
        console.error('Error refreshing IPS:', e);
        return {error: 'unknown'};
    }
});

export const api = {
    manual_oculus_renew,
    update_auto_renewal,
    update_extra_limit_renewal,
    buy_extra_limit,
    create_free_zone,
    create_zone_for_group,
    update_orders_user_state,
    generate_kyc_access_token,
    check_kyc_status,
    zone_set_use_case,
    zone_rotate_by_country,
    delete_payment_method,
    update_user_ui_state,
    get_zone_sessions,
    update_zone_config,
    update_zone,
    archive_zone_toggle,
    zone_update_usage_limit,
    zone_update_whitelist,
    do_zone_action,
    get_task_result_by_session_id,
    get_resource_from_task_result_by_id,
    get_zone_usage_stats,
    get_account_bootstrap,
    create_new_task,
    task_add_instructions,
    task_send_command,
    refresh_ips,
    configure_proxies,
};
